import { IconBook } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const DocsPage = lazy(() => import("./DocsPage").then((m) => ({ default: m.DocsPage })));

// Same audience as the Integration page: the guide shows the API key.
export const routes: FeatureRoute[] = [
  {
    path: "/portal/docs",
    roles: CAPS.portal.integration,
    element: createElement(Suspense, { fallback: null }, createElement(DocsPage)),
  },
];

export const nav: NavItem[] = [
  {
    label: "Integration guide",
    path: "/portal/docs",
    icon: IconBook,
    surface: "portal",
    roles: CAPS.portal.integration,
  },
];
